import React from 'react';
import PropTypes from 'prop-types';
import RenderDateTimeInputField from 'components/form/InputFields/RenderDateTimeInputField';
import RenderLocationInputField from 'components/form/InputFields/RenderLocationInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import categoryHelper from 'helpers/category';
import normalisations from 'helpers/forms/normalisations';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { Field } from 'redux-form';
import styled from 'styled-components';

const StyledWrapper = styled.div`
    width: 700px;
`;

const Input = (props) => {
    const {
        categoryId,
        translate,
    } = props;

    const isBikeProduct = categoryHelper.isBike(categoryId);
    const isHubProduct = categoryHelper.isHub(categoryId);
    const isParkingProduct = categoryHelper.isParking(categoryId);
    const isTaxiProduct = categoryHelper.isTaxi(categoryId);
    const isTransferProduct = categoryHelper.isTransfer(categoryId);

    return (
        <StyledWrapper>
            { (isBikeProduct || isHubProduct || isParkingProduct) &&
                <Field
                    component={ RenderDateTimeInputField }
                    label={ translate('resources.orders.filters.destination_arrival_date.label') }
                    name='destination_arrival_date'
                    placeholder={ translate('resources.orders.filters.destination_arrival_date.placeholder') }
                />
            }

            { (isBikeProduct || isHubProduct || isParkingProduct) &&
                <Field
                    component={ RenderDateTimeInputField }
                    label={ translate('resources.orders.filters.destination_departure_date.label') }
                    name='destination_departure_date'
                    placeholder={ translate('resources.orders.filters.destination_departure_date.placeholder') }
                />
            }

            { (isTaxiProduct || isTransferProduct) &&
                <Field
                    component={ RenderDateTimeInputField }
                    label={ translate('resources.orders.fields.pick_up_date') }
                    name='destination_arrival_date'
                    placeholder={ translate('resources.orders.filters.destination_arrival_date.placeholder') }
                />
            }

            { (isTaxiProduct || isTransferProduct) &&
                <Field
                    component={ RenderLocationInputField }
                    fullWidth={ true }
                    label={ translate('resources.orders.fields.origin_address') }
                    name='origin_address'
                />
            }

            { (isTaxiProduct || isTransferProduct) &&
                <Field
                    component={ RenderLocationInputField }
                    fullWidth={ true }
                    label={ translate('resources.orders.fields.destination_address') }
                    name='destination_address'
                />
            }

            { (!isBikeProduct && !isHubProduct) &&
                <Field
                    component={ RenderTextInputField }
                    label={ translate('resources.orders.fields.number_of_persons') }
                    name='number_of_persons'
                    normalize={ normalisations.integer }
                    type='number'
                    validate={ validations.required }
                />
            }
        </StyledWrapper>
    );
};

Input.propTypes = {
    categoryId: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(Input);



// WEBPACK FOOTER //
// ./src/pages/bookings/amend/phase/form/Input.js